<template>
    <JetFormSection @submitted="updateSettingTahunAktif">
        <template #title>
            Tahun Aktif
        </template>

        <template #description>
            Setting tahun aktif aplikasi
        </template>

        <template #form>
            <!-- Tahun Aktif -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tahun_aktif" value="Tahun Aktif" />
                <Select id="tahun_aktif" class="mt-1 block w-full" :options="$page.props.options.tahun_pilihan" v-model="form.tahun_aktif" /> <!-- $page.props.tahun_aktif -->
                <JetInputError :message="form.errors.tahun_aktif" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <InertiaButtonSave :class="{ 'opacity-25': form.processing }" label="Simpan" />
        </template>
    </JetFormSection>
</template>

<script>
    import { defineComponent } from 'vue';
    import JetButton from '@/Jetstream/Button';
    import JetFormSection from '@/Jetstream/FormSection';
    import JetInput from '@/Jetstream/Input';
    import Select from '@/Components/Select';
    import JetInputError from '@/Jetstream/InputError';
    import JetLabel from '@/Jetstream/Label';
    import InertiaButtonSave from '@/Components/InertiaButtonSave.vue';

    export default defineComponent({
        components: {
            JetButton,
            JetFormSection,
            JetInput,
            Select,
            JetInputError,
            JetLabel,
            InertiaButtonSave,
        },
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'PUT',
                    tahun_aktif: this.$page.props.setting.tahun_aktif,
                }),
            }
        },
        methods: {
            updateSettingTahunAktif() {
                this.form.post(route('setting.tahunaktif.save'), {
                    errorBag: 'updateSettingTahunAktif',
                    preserveScroll: true,
                    // onSuccess: () => (this.clearPhotoFileInput()),
                });
            },
        },
    })
</script>
